import { JobTitleEnum, RequiredJobTitle } from '@pflegia/types/api/job-title';

export const isCompanion = ({ title }: RequiredJobTitle) => title === JobTitleEnum.Companion;
